import { render, staticRenderFns } from "./ruleManagement.vue?vue&type=template&id=23660d32&scoped=true&"
import script from "./ruleManagement.vue?vue&type=script&lang=js&"
export * from "./ruleManagement.vue?vue&type=script&lang=js&"
import style0 from "./ruleManagement.vue?vue&type=style&index=0&id=23660d32&prod&lang=css&"
import style1 from "./ruleManagement.vue?vue&type=style&index=1&id=23660d32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23660d32",
  null
  
)

export default component.exports